<header class="header">

  <!-- Hambúrguer para telas menores -->
  <button
    type="button"
    class="header__menu-btn"
    (click)="toggleSidebar.emit()"
    [attr.aria-label]="sidebarOpen ? 'Fechar menu' : 'Abrir menu'"
    [attr.aria-expanded]="sidebarOpen"
    aria-controls="main-navigation"
  >
    <i class="bi bi-list"></i>
  </button>

  <!-- Centro: breadcrumb / título da página (slot reservado) -->
  <div class="header__center"></div>

  <!-- Direita: ações + avatar do usuário -->
  <div class="header__actions">

    @if (institutions().length > 0) {
      <div class="header__institution" title="Instituição ativa">
        <button
          type="button"
          class="header__institution-trigger"
          [class.header__institution-trigger--open]="institutionDropdownOpen()"
          [attr.aria-expanded]="institutionDropdownOpen()"
          aria-haspopup="listbox"
          aria-label="Instituição ativa"
          (click)="toggleInstitutionDropdown()"
        >
          <i class="bi bi-bank" aria-hidden="true"></i>
          <span class="header__institution-name">{{ selectedInstitutionName() }}</span>
          <i class="bi bi-chevron-down header__institution-chevron" aria-hidden="true"></i>
        </button>

        @if (institutionDropdownOpen()) {
          <div class="header__institution-menu" role="listbox" aria-label="Instituições">
            @for (institution of institutions(); track institution.id) {
              <button
                type="button"
                class="header__institution-option"
                [class.header__institution-option--selected]="isSelectedInstitution(institution)"
                [attr.aria-selected]="isSelectedInstitution(institution)"
                role="option"
                (click)="selectInstitution(institution)"
              >
                <span class="header__institution-check" aria-hidden="true">
                  @if (isSelectedInstitution(institution)) {
                    <i class="bi bi-check-lg"></i>
                  }
                </span>
                <span class="header__institution-option-text">{{ institution.name }}</span>
              </button>
            }
          </div>
        }
      </div>
    }

    <button
      type="button"
      class="header__icon-btn header__notification-btn"
      [class.header__notification-btn--active]="unreadMessages() > 0"
      [attr.aria-label]="unreadMessagesLabel()"
      [title]="unreadMessagesLabel()"
      (click)="refreshUnreadMessages()"
    >
      <i class="bi bi-bell" aria-hidden="true"></i>
      @if (unreadMessages() > 0) {
        <span class="header__notification-badge" aria-hidden="true">{{ unreadMessagesBadge() }}</span>
      }
    </button>

    <!-- Divisor -->
    <span class="header__divider" aria-hidden="true"></span>

    <!-- User trigger -->
    <div class="header__user-wrap">
      <button
        type="button"
        class="header__trigger"
        (click)="toggleDropdown()"
        [class.header__trigger--open]="dropdownOpen()"
        [attr.aria-expanded]="dropdownOpen()"
        aria-haspopup="true"
        aria-label="Menu do usuário"
      >
        <!-- Avatar com iniciais -->
        <span class="header__avatar" aria-hidden="true">{{ initials() }}</span>

        <!-- Info do usuário -->
        <span class="header__user-info">
          <span class="header__user-name">{{ firstName() }}</span>
          @if (user(); as u) {
            <span class="header__user-email">{{ u.email }}</span>
          }
        </span>

        <!-- Chevron -->
        <svg
          class="header__chevron"
          [class.header__chevron--open]="dropdownOpen()"
          width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          aria-hidden="true"
        >
          <polyline points="6 9 12 15 18 9"/>
        </svg>
      </button>

      <!-- Dropdown -->
      @if (dropdownOpen()) {
        <div class="header__dropdown" role="menu">
          <!-- Cabeçalho do dropdown -->
          <div class="header__dropdown-header">
            <span class="header__dropdown-avatar" aria-hidden="true">{{ initials() }}</span>
            <div class="header__dropdown-info">
              @if (user(); as u) {
                @if (u.name) {
                  <span class="header__dropdown-name">{{ u.name }}</span>
                }
                <span class="header__dropdown-email">{{ u.email }}</span>
              }
            </div>
          </div>

          <div class="header__dropdown-divider" aria-hidden="true"></div>

          <!-- Ações -->
          <div class="header__dropdown-body" role="none">
            <button type="button" class="header__dropdown-item" role="menuitem">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
              Meu perfil
            </button>
          </div>

          <div class="header__dropdown-divider" aria-hidden="true"></div>

          <div class="header__dropdown-footer" role="none">
            <button
              type="button"
              class="header__dropdown-item header__dropdown-item--danger"
              role="menuitem"
              (click)="logout()"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
              Sair
            </button>
          </div>
        </div>
      }
    </div>
  </div>

</header>
